import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  DiNodejs,
  DiGit,
  DiGithub,
  DiHtml5,
  DiCss3,
  DiReact,
  DiBootstrap,
} from "react-icons/di";
import {
  SiTailwindcss,
  SiFirebase,
  SiVite,
  SiExpress,
  SiDaisyui,
  SiNetlify,
  SiVercel,
} from "react-icons/si";

function Techstack() {
  return (
     <Container style={{ textAlign: "center" }}>
      <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
        <Col xs={5} md={2} className="tech-icons"><DiHtml5 title="HTML" /></Col>
        <Col xs={5} md={2} className="tech-icons"><DiCss3 title="CSS" /></Col>
        <Col xs={5} md={2} className="tech-icons"><DiReact title="React JS" /></Col>
        <Col xs={5} md={2} className="tech-icons"><SiExpress title="Express JS" /></Col>
        <Col xs={5} md={2} className="tech-icons"><SiVite title="Vite JS" /></Col>
        <Col xs={5} md={2} className="tech-icons"><DiNodejs title="Node JS" /></Col>
        <Col xs={5} md={2} className="tech-icons"><DiGit title="Git" /></Col>
        <Col xs={5} md={2} className="tech-icons"><DiGithub title="GitHub" /></Col>
        <Col xs={5} md={2} className="tech-icons"><SiNetlify title="Netlify" /></Col>
        <Col xs={5} md={2} className="tech-icons"><SiVercel title="Vercel" /></Col>
        <Col xs={5} md={2} className="tech-icons"><SiTailwindcss title="Tailwind CSS" /></Col>
        <Col xs={5} md={2} className="tech-icons"><DiBootstrap title="Bootstrap" /></Col>
        <Col xs={5} md={2} className="tech-icons"><SiDaisyui title="Daisy UI" /></Col>
        <Col xs={5} md={2} className="tech-icons"><SiFirebase title="Firebase" /></Col>
      </Row>
    </Container>

  );
}

export default Techstack;

